import { c as _c } from "react/compiler-runtime";
export default function GalleryModeIcon(t0) {
  const $ = _c(9);
  const {
    showGrid
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><title>Carousel view</title><rect width="12" height="12" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== showGrid) {
    t2 = <span className="absolute inset-0 grid place-items-center transition-opacity duration-300 data-[show-grid=false]:opacity-0 data-[show-grid=true]:opacity-100" data-show-grid={showGrid} aria-hidden="true">{t1}</span>;
    $[1] = showGrid;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !showGrid;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><title>Grid view</title><rect width="5" height="5" /><rect x="7" width="5" height="5" /><rect x="7" y="7" width="5" height="5" /><rect y="7" width="5" height="5" /></svg>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <span className="absolute inset-0 grid place-items-center transition-opacity duration-300 data-[show-grid=false]:opacity-0 data-[show-grid=true]:opacity-100" aria-hidden="true" data-show-grid={t3}>{t4}</span>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = <div className="hover:text-not-active! text-active relative block size-3 opacity-50 hover:opacity-100">{t2}{t5}</div>;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}